import './AnalyseSkillsTextButton.css';
import { Description } from '@mui/icons-material';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import Button from '@src/App/Components/Buttons/Button/Button';
import { useDialog } from '@src/App/Components/Dialogs/DialogManager';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

import AnalyseCvDialog from '../../Dialogs/AnalyseSkillsDialog/AnalyseCvDialog';

/**
 * AnalyseSkillsTextButton component.
 *
 * @param {AnalyseSkillsTextButtonProps} props - The props object for the component.
 * @returns {JSX.Element} The rendered AnalyseSkillsTextButton component.
 */
function AnalyseSkillsTextButton() {
    const { openDialog } = useDialog();

    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).profileSettings;
    const offline = useSelector((state: AppState) => state.client.offline);

    return (
        <div className="analyseSkillsTextButton">
            <Button
                size="normal"
                text={langStrings.analyseText}
                icon={<Description />}
                onClick={async () => {
                    openDialog(
                        <AnalyseCvDialog
                            id="AnalyseCvDialog"
                            initialLoadingText={''}
                            file={undefined}
                            resolve={() => {
                                return;
                            }}
                        />,
                    );
                    (document.getElementById('fileButton') as HTMLInputElement).value = '';
                }}
                disabled={offline}
            />
        </div>
    );
}

export default AnalyseSkillsTextButton;
